<template>
    <!--  首字母组件  -->
    <ul class="initial-box">
        <li :class="value === selectValue ? 'normal-span select-box' : 'normal-span'" v-for="(value, index) in initialList" :key="index" @click="clickSpan(index)">
            <span>{{value}}</span>
        </li>
    </ul>
</template>

<script setup>
    import {ref} from "vue";

    const props = defineProps(["initialList"])
    const emits = defineEmits(["clickInitial"])

    const selectValue = ref(null)
    
    function clickSpan(index) {
        const value = props.initialList[index]

        if (value === selectValue.value){
            selectValue.value = null
            emits("clickInitial", null)
        }else{
            selectValue.value = value
            emits("clickInitial", value, index)
        }

    }

</script>

<style scoped>
    .initial-box {
        padding: 0;
        list-style: none;
        width: 2em;
        text-align: center;
        font-size: 16px;
        line-height: 2;
        user-select: none;
        transition: 0.25s all ease;
    }

    /*.initial-box li:hover {*/
    /*    background: #ddd;*/
    /*    color: #e83f33;*/
    /*}*/

    .select-box {
        background: #ddd;
        color: #e83f33;
        cursor: pointer;
    }

    .normal-span {
        color: #73767a;
        cursor: pointer;
        font-size: 14px;
        padding: 4px 0;
    }

</style>